import axios from 'axios';
import { MAIL_API_BASE } from './constants';
import {
  MailFolder,
  MailMessageSummary,
  MailMessageDetail,
  MailSessionCheckResponse,
  MailMessagesResponse
} from './types';

/**
 * Проверка статуса авторизации в корпоративной почте
 */
export async function checkMailAuth(username: string): Promise<MailSessionCheckResponse> {
  const response = await axios.get<MailSessionCheckResponse>(`${MAIL_API_BASE}/check-auth`, {
    params: { username }
  });
  return response.data;
}

/**
 * Получение списка папок с количеством непрочитанных и общим числом писем
 */
export async function fetchMailFolders(username: string): Promise<MailFolder[]> {
  const response = await axios.get<{ success: boolean; folders: MailFolder[] }>(
    `${MAIL_API_BASE}/folders`,
    { params: { username } }
  );
  return response.data?.folders || [];
}

/**
 * Поиск и получение списка писем в указанной папке
 */
export async function fetchMailMessages(
  username: string,
  folder = 'inbox',
  query?: string,
  limit = 50,
  offset = 0
): Promise<MailMessagesResponse> {
  const response = await axios.get<MailMessagesResponse>(`${MAIL_API_BASE}/messages`, {
    params: {
      username,
      folder,
      query: query || undefined,
      limit,
      offset
    }
  });
  return response.data;
}

/**
 * Загрузка подробного содержимого письма (тело, вложения, получатели)
 */
export async function fetchMailMessageDetail(
  username: string,
  id: string
): Promise<MailMessageDetail> {
  const response = await axios.get<{ success: boolean; message: MailMessageDetail }>(
    `${MAIL_API_BASE}/message/${encodeURIComponent(id)}`,
    { params: { username } }
  );
  if (!response.data?.success || !response.data?.message) {
    throw new Error('Не удалось загрузить письмо');
  }
  return response.data.message;
}

/**
 * Выполнение действия над письмом:
 * op = 'read' | '!read' | 'trash' | 'delete' | 'flag' | '!flag'
 */
export async function executeMailAction(
  username: string,
  id: string,
  op: string
): Promise<void> {
  await axios.post(`${MAIL_API_BASE}/action`, {
    username,
    id,
    op
  });
}

/**
 * Формирование прямого URL для скачивания вложения
 */
export function getAttachmentDownloadUrl(
  username: string,
  id: string,
  part: string,
  filename: string
): string {
  const params = new URLSearchParams({
    username,
    id,
    part,
    filename
  });
  return `${MAIL_API_BASE}/attachment?${params.toString()}`;
}
